import PropTypes from "prop-types";
import React from "react";

import {
  Pagination,
  HitsPerPage,
  Stats,
  PoweredBy,
} from "react-instantsearch-dom";

import Hits from "../components/Hits";
import TrackColumnsSort from "../components/TrackColumnsSort";

import "./tracks-list.scss";

const getIndexName = (indexName) => {
  return indexName.replace("HIFI", window.HIFI_APP.HIFI_ALGOLIA_INDEX_NAME);
};

/**
 * Tracks List.
 *
 * @param {object} root0 Props.
 * @param {Array} root0.tracks Array of tracks.
 */
function TracksList() {
  return (
    <React.Fragment>
      <TrackColumnsSort
        defaultRefinement={getIndexName("HIFI")}
        items={[
          { value: getIndexName("HIFI"), label: "Title ASC" },
          { value: getIndexName("HIFI_title_desc"), label: "Title DESC" },
          { value: getIndexName("HIFI_length_asc"), label: "Length ASC" },
          { value: getIndexName("HIFI_length_desc"), label: "Length DESC" },
        ]}
      />
      <div className="tracks-list-wrapper">
        <div className="tracks-list">
          <Hits />
        </div>
      </div>
      <Pagination />
      <div className="hits-per-page__wrapper">
        <small className="hits-per-page__label">Tracks Per Page</small>
        <HitsPerPage
          defaultRefinement={20}
          items={[
            { value: 20, label: "20" },
            { value: 50, label: "50" },
            { value: 100, label: "100" },
          ]}
        />
      </div>
      <Stats />
      {/* <PoweredBy /> */}
    </React.Fragment>
  );
}

TracksList.defaultProps = {
  tracks: [],
};

TracksList.propTypes = {
  tracks: PropTypes.arrayOf(
    PropTypes.shape({
      objectID: PropTypes.number.isRequired,
    })
  ),
};

export default TracksList;
